import Text from 'components/Text'
import If from '@mobi/components/If'

import './installmentDropdown.scss'

const InstallmentDropdown = ({
  valueInstallment,
  highlight,
  selectInstallmentId,
  isActive,
}) => {
  const isInCash = valueInstallment.installmentNumber === 1

  return (
    <div
      key={valueInstallment.id}
      className={`price-percentage-dropdown ${highlight ? '-highlight' : ''} ${
        selectInstallmentId === valueInstallment.id ? '-selected' : ''
      }`}
    >
      <div aria-hidden={selectInstallmentId === valueInstallment.id}>
        <Text p size={3}>
          {highlight ? (
            <>
              <If
                condition={isActive}
                renderIf="selecione o parcelamento"
                renderElse={
                  <>
                    <small>
                      {isInCash
                        ? 'à vista'
                        : `em ${valueInstallment.installmentNumber}x de`}
                    </small>
                    {valueInstallment.installmentValue}
                  </>
                }
              />
            </>
          ) : (
            <>
              {isInCash
                ? 'à vista'
                : `${valueInstallment.installmentNumber}x de`}
              {valueInstallment.installmentValue}
            </>
          )}
        </Text>
      </div>
    </div>
  )
}

export default InstallmentDropdown
